// lbl.home
export const home = {
    title: "สวัสดี โลก!",
};
